module.exports = require("i18next-chained-backend");